import React from 'react'
import Helmet from 'react-helmet'
import favicon from '../images/favicon.ico'
import Container from '../Layout/Container'
import Layout from '../Layout/Layout'
import PageHeader from '../sections/PageHeaderSection'
import ROIMultiStepper from '../components/ROIMultiStepper'
import SEO from '../components/seo'
import TextHeader from '../components/TextHeader'

const ROICalculatorPage = () => (
  <Layout>
    <SEO
      title="roi-calculator"
      url="https://www.mailgun.com/email-marketing-roi-calculator/"
      type="website"
    />
    <Helmet defer={false}>
      <title>Email Marketing ROI Calculator</title>
      <meta
        name="description"
        content="Do all your emails make it into the inbox? See how much additional revenue a 1% increase in email deliverability can do, and how Mailgun will help you get there."
      />
      <meta name="robots" content="index,follow" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Email Marketing ROI Calculator | Mailgun" />
      <meta property="og:description" content="Do all your emails make it into the inbox? See how much additional revenue a 1% increase in email deliverability can do, and how Mailgun will help you get there." />
      <meta property="og:site_name" content="Mailgun" />
      <meta property="og:image" content={require('../images/mailgun.png')} />

      <meta name="twitter:title" content="Email Marketing ROI Calculator | Mailgun" />
      <meta name="twitter:description" content="Do all your emails make it into the inbox? See how much additional revenue a 1% increase in email deliverability can do, and how Mailgun will help you get there." />
      <meta name="twitter:image" content={require('../images/mailgun.png')} />
      <link rel="canonical" href="https://www.mailgun.com/email-marketing-roi-calculator/" />
      <link rel="icon" href={favicon} />
    </Helmet>

    <Container fullWidth>
      <PageHeader>
        <main>
          <TextHeader
            mdTitle="# Mailgun's Email Marketing ROI Calculator"
            subtitle="mailgun roi calculator"
            text="Answer a few short questions to get a customized report on the performance of your email program, and learn how Mailgun can help increase your email ROI."
            theme={{
              align: 'center',
              color: 'white',
              size: 'big',
            }}
          />
        </main>
        <article>
          <ROIMultiStepper />
        </article>
      </PageHeader>
    </Container>
  </Layout>
)

export default ROICalculatorPage
